import React, { createContext, useState } from "react"

export const WestgardRulesContext = createContext()

export const WestgardRulesProvider = ({ children }) => {
  const [listRulesSelectedUnique, setListRulesSelectedUnique] = useState([])
  const [dataConfigAnalyte, setDataConfigAnalyte] = useState({ anlt_cname: "" })
  const [isSigma, setIsSigma] = useState(false)

  return (
    <WestgardRulesContext.Provider
      value={{
        listRulesSelectedUnique,
        setListRulesSelectedUnique,
        dataConfigAnalyte,
        setDataConfigAnalyte,
        isSigma,
        setIsSigma,
      }}
    >
      {children}
    </WestgardRulesContext.Provider>
  )
}
